// src/routes/index.tsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import HomeRoutes from "./HomeRoutes";
import AdminRoutes from "./AdminRoutes";
import UserRoutes from "./UserRoutes";

export const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Home routes - catch-all for the main site */}
      <Route path="/*" element={<HomeRoutes />} />
      <Route path="/admin/*" element={<AdminRoutes />} />
      <Route path="/user/*" element={<UserRoutes />} />
    </Routes>
  );
};

export default AppRoutes;
